import { lazy, Suspense } from 'react';
import { Outlet, useRoutes } from 'react-router-dom';

import { MainLayout } from 'src/layouts/main';

import { SplashScreen } from 'src/components/loading-screen';

import { paths } from '../paths';
import { jobsRoutes } from './jobs';
import { authRoutes } from './auth';
import { staffRoutes } from './staff';
import { tasksRoutes } from './tasks';
import { clientsRoutes } from './clients';
import { libraryRoutes } from './library';
import { accountRoutes } from './account';
import { companiesRoutes } from './companies';
import { dashboardRoutes } from './dashboard';
import { subscriptionRoutes } from './subscription';

// ----------------------------------------------------------------------

const HomePage = lazy(() => import('src/pages/home'));
const ComingSoonPage = lazy(() => import('src/pages/coming-soon'));
const PricingPage = lazy(() => import('src/pages/pricing'));
const FaqsPage = lazy(() => import('src/pages/faqs'));

const NotFoundPage = lazy(() => import('src/pages/error/404'));

export function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <MainLayout>
            <Outlet />
          </MainLayout>
        </Suspense>
      ),
      children: [
        { index: true, Component: HomePage },
        { path: paths.features, Component: ComingSoonPage },
        { path: paths.pricing, Component: PricingPage },
        { path: paths.faqs, Component: FaqsPage },
        { path: paths.about, Component: ComingSoonPage },
        { path: paths.contact, Component: ComingSoonPage },
        { path: paths.careers, Component: ComingSoonPage },
        { path: paths.blog, Component: ComingSoonPage },
        { path: paths.documentation, Component: ComingSoonPage },
        { path: paths.support, Component: ComingSoonPage },
        { path: paths.privacyPolicy, Component: ComingSoonPage },
        { path: paths.termsOfService, Component: ComingSoonPage },
        { path: paths.cookiePolicy, Component: ComingSoonPage },
      ]
    },
    // Auth
    ...authRoutes,
    // ...authDemoRoutes,

    // Dashboard
    ...dashboardRoutes,

    // Main
    // ...mainRoutes,

    // Components
    // ...componentsRoutes,

    // Audit Pulse Pro
    ...companiesRoutes,
    ...staffRoutes,
    ...clientsRoutes,
    ...jobsRoutes,
    ...libraryRoutes,
    ...tasksRoutes,
    ...accountRoutes,
    ...subscriptionRoutes,

    // No match
    { path: '*', element: <NotFoundPage /> },
  ]);
}
